<!--
    file type .....: HTML file: event-messages.component.html
    Created By ....: ianday
    Date ..........: 2/28/24 
-->
<div class="event-messages-container">
    <div class="heading-text-style">Automated Messages</div>

    <div class="dwform" style="margin-left:20px">

    <div class="dwform-row-gap"></div>

    <div class="table-container mat-elevation-z1"
          (keydown)="tableKeyDown($event)" tabindex="-1">
        <table mat-table [dataSource]="dataSource" matSort style="width:100%;"
               (matSortChange)="onSortChange($event)">
            <!-- Application Event Id -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="table-row" [hidden]="true"
                    style="background-color: white; z-index:99999; width: 45px;">Id
                </th>
                <td mat-cell style="width:45px !important;" class="table-row" [hidden]="true"
                    *matCellDef="let element">{{ element.id }}
                </td>
            </ng-container>
            <!-- Application Event Description -->
            <ng-container matColumnDef="eventDescription">
                <th mat-header-cell *matHeaderCellDef class="table-row"
                    style="background-color: white; z-index:99999; width: 220px;padding-left: 5px;">Event
                </th>
                <td mat-cell style="width:45%;padding-left: 5px;" class="table-row"
                    *matCellDef="let element">{{ element.eventDescription }}
                </td>
            </ng-container>
            <!-- Message definition id -->
            <ng-container matColumnDef="messageId">
                <th mat-header-cell *matHeaderCellDef [hidden]="true"
                    style="background-color: white; z-index:99999; width: 25px;">
                </th>
                <td mat-cell style="width:25px;" [hidden]="true"
                    *matCellDef="let element">{{ element.messageId }}
                </td>
            </ng-container>
            <!-- Message Description -->
            <ng-container matColumnDef="messageDescription">
                <th mat-header-cell *matHeaderCellDef class="table-row"
                    style="background-color: white; z-index:99999; width: 220px;">Message
                </th>

                <td mat-cell style="width:45%;" class="table-row" *matCellDef="let element">
                    <dw-dropdown *ngIf="(selectedRecord?.id == element.id) "
                                 [ngStyle]="{'color':returnMessageColor(selectedRecord?.messageId)}"
                                 [disabled]="editMode || !visibleModify"
                                 [selectedItem]="element.messageId"
                                 [dataSource]="messageDropDownItems"
                                 [controlWidth]="'250px'"
                                 (itemSelected)="element.messageId = $event; onMessageChange(element)">
                    </dw-dropdown>

                    <span *ngIf="selectedRecord?.id !== element.id"
                    [ngStyle]="{'color':returnMessageColor(element.messageId)}"

                    >{{element.messageDescription}}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)">
            </tr>

        </table>
    </div>
</div>
